import { Chip, ChipProps } from "@clarityos/ui/chip";
import { PaymentDisplayStatus } from "lib/api-types/schemas";
import CheckFilledIcon from "../../../../public/icons/check-filled.svg";
import ClockFilledIcon from "../../../../public/icons/clock-filled.svg";
import MenuCircle from "../../../../public/icons/menu-circle.svg";
import PartialIcon from "../../../../public/icons/partial-11px.svg";
import { twMerge } from "tailwind-merge";

const STATUS_CONFIG: Record<
  Exclude<PaymentDisplayStatus, "Cancelled">,
  {
    label: string;
    color: ChipProps["color"];
    icon: typeof CheckFilledIcon;
    className?: string;
  }
> = {
  [PaymentDisplayStatus.Paid]: {
    label: "Paid",
    color: "positive",
    icon: CheckFilledIcon,
  },
  [PaymentDisplayStatus.Unpaid]: {
    label: "Unpaid",
    color: "inactive",
    icon: ClockFilledIcon,
  },
  [PaymentDisplayStatus.External]: {
    label: "External",
    color: "external",
    icon: MenuCircle,
    className: "border border-dashed border-stroke-dashed",
  },
  [PaymentDisplayStatus.PartiallyPaid]: {
    label: "Partially Paid",
    color: "warning",
    icon: PartialIcon,
  },
};

export const STATEMENT_STATUS_LABEL: Record<PaymentDisplayStatus, string> =
  Object.fromEntries(
    Object.entries(STATUS_CONFIG).map(([status, { label }]) => [status, label]),
  ) as Record<PaymentDisplayStatus, string>;

interface Props {
  status: PaymentDisplayStatus;
  className?: string;
}

export function StatementStatusBadge({
  status,
  className: classNameProps,
}: Props) {
  if (status === "Cancelled") return null;

  const config = STATUS_CONFIG[status];

  if (!config) return null;

  const { label, color, className, icon: Icon } = config;

  return (
    <Chip
      color={color}
      startAdornment={<Icon />}
      className={twMerge(className, classNameProps)}
    >
      {label}
    </Chip>
  );
}
